import { FC } from "react";
import { Button, Stack, Text } from "@chakra-ui/react";

interface Props {
  text: string;
  onClose: () => void;
}

export const MainPageSbpTransferModal: FC<Props> = ({ text, onClose }) => {
  return (
    <Stack pt="10px" px="4px" spacing={0}>
      <Text fontSize="14px" textAlign="center">{text}</Text>

      <Button onClick={onClose} mt="22px">Понятно</Button>
    </Stack>
  );
};
